import React from "react";
import "./hotspotVideoModal.css";
import ReactPlayer from "react-player";

const VideoModal = ({ open, onClick, closeIcon, posterUrl, videoUrl }) => {
  return (
    <div
      style={{
        zIndex: "1",
        maxWidth: "100vh",
        backgroundColor: "transparent",
        // maxHeight: "90vh",
        alignSelf: "center",
        padding: "4rem",
        border: "none",
        position: "relative",
      }}
    >
      <div className="video-close-icon" onClick={() => onClick()}>
        <img src={closeIcon} alt="close" />
      </div>
      <div className="video-player">
        <ReactPlayer
          playing
          controls
          light={
            <img
              src={posterUrl}
              alt="Thumbnail"
              width={"100%"}
              height={"100%"}
            />
          }
          url={videoUrl}
          width={"100%"}
          height={"100%"}
          playsinline
        />
      </div>
    </div>
  );
};

export default VideoModal;
